import React from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

const Audio = ({ testStarted, audio }) => {
    return (
        <div className='mock-test col-lg-8 col-md-6 p-4'>
            <AudioPlayer
                autoPlay={testStarted ? true : false}
                // src="http://media.intergreat.com/Audio/Mock_Test_2018/11/Practice%20Test%201.mp3"
                src={audio?.voice_over}
                className='listening-audio-player'
                customAdditionalControls={[]}
                showDownloadProgress={false}
            />
        </div>
    )
}

export default Audio;